<div class="my-3 p-3 new-series-container">
  <div class="d-flex justify-content-between mb-2">
    <div class="text-primary font-weight-bold">
      {{ "DATA_STUDIO.DATA_ANALYSIS.ADD_NEW" |translate }}
      <small class="ml-3 mt-1">
        <mat-checkbox
          [checked]="sameDeviceBothSignals"
          (change)="toggleSameDeviceBothSignals()">
          {{'DATA_STUDIO.DATA_ANALYSIS.USE_SAME_DEVICE_FOR_SIGNALS' | translate}}
        </mat-checkbox>
      </small>
    </div>
    <lib-button
      id="new-scatter-plot-close-button"
      [size]="'custom'"
      [width]="30"
      [color]="'primary-link'"
      [faIcon]="'far fa-times'"
      (buttonClicked)="close()" >
    </lib-button>
  </div>
  <div class="d-flex mb-2">

    <!-- Parks -->
    <div class="mr-4">
      <div class="mb-2 font-size-small">{{ "DATA_STUDIO.DATA_ANALYSIS.PARKS_TITLE" |translate }}</div>
      <div class="selection-container">
        @if (addNewSignal) {
          @if (!parks?.length) {
            <div class="h-100 p-2 d-flex align-items-center font-size-small new-scatter-plot-item">
              {{ "DATA_STUDIO.DATA_ANALYSIS.LOADING_PARKS" |translate }}<app-timer></app-timer>
            </div>
          }
          @if (parks?.length) {
            <lib-select
              [label]="selectedPark?.fe_name || 'DATA_STUDIO.DATA_PARAMETERS.SELECT_PARK' |translate"
              [border]="'custom-border'"
              [fullWidth]="true"
              [notBold]="true"
              [classes]="'font-size-normal-small text-primary h-100 text-left'"
              [itemClasses]="'font-size-normal-small'"
              [options]="parksNames"
              [doNotTranslate]="true"
              (selectedChanged)="selectPark($event)"
            ></lib-select>
          }
        }
      </div>
    </div>

    <!-- Device-X -->
    <div class="mr-4">
      <div class="mb-2 font-size-small">
        <span>{{ "DATA_STUDIO.DATA_ANALYSIS.DEVICE_X_AXIS" |translate }}</span>
      </div>
      <div class="selection-container">
        @if (addNewSignal) {
          @if (!devicesList?.length) {
            <div class="p-2 d-flex align-items-center font-size-small new-scatter-plot-item">
              {{ "DATA_STUDIO.DATA_ANALYSIS.NO_SELECTION" |translate }}
            </div>
          }
          @if (devicesList?.length) {
            <div class="items-list mt-2">
              @if (devicesList?.length) {
                <lib-select
                  [label]="(selectedDevice?.code | noUnderscore) || 'DATA_STUDIO.DATA_PARAMETERS.SELECT_DEVICE' |translate"
                  [border]="'custom-border'"
                  [fullWidth]="true"
                  [notBold]="true"
                  [classes]="'font-size-normal-small text-primary h-100 text-left'"
                  [itemClasses]="'font-size-normal-small'"
                  [options]="devicesListNames"
                  [doNotTranslate]="true"
                  [disabled]="!selectedPark"
                  (selectedChanged)="selectDevice($event)"
                ></lib-select>
              }
            </div>
          }
        }
      </div>
    </div>

    <!-- Signal-X -->
    <div class="mr-4">
      <div class="mb-2 font-size-small">
        <span>{{ "DATA_STUDIO.DATA_ANALYSIS.SIGNAL_X_TITLE" |translate }}</span>
      </div>
      <div class="selection-container">
        @if (addNewSignal) {
          @if (!signalsXAxis?.length) {
            <div class="p-2 d-flex align-items-center font-size-small new-scatter-plot-item">
              {{ "DATA_STUDIO.DATA_ANALYSIS.NO_SIGNAL" |translate }}
            </div>
          }
          @if (signalsXAxis?.length) {
            <div class="items-list mt-2">
              @if (signalsXAxis?.length) {
                <lib-select
                  [label]="signalXLabel"
                  [border]="'custom-border'"
                  [fullWidth]="true"
                  [notBold]="true"
                  [classes]="'font-size-normal-small text-primary h-100 text-left'"
                  [itemClasses]="'font-size-normal-small'"
                  [options]="signalsXAxisNames"
                  [doNotTranslate]="false"
                  [disabled]="!selectedDevice || !selectedPark"
                  (selectedChanged)="selectSignalX($event)"
                ></lib-select>
              }
            </div>
          }
        }
      </div>
    </div>

    <!-- Device-Y -->
    @if (!sameDeviceBothSignals) {
      <div class="mr-4">
        <div class="mb-2 font-size-small">
          <span>{{ "DATA_STUDIO.DATA_ANALYSIS.DEVICE_Y_AXIS" |translate }}</span>
        </div>
        <div class="selection-container">
          @if (addNewSignal) {
            @if (!devicesList?.length) {
              <div class="p-2 d-flex align-items-center font-size-small new-scatter-plot-item">
                {{ "DATA_STUDIO.DATA_ANALYSIS.NO_SELECTION" |translate }}
              </div>
            }
            @if (devicesList?.length) {
              <div class="items-list mt-2">
                @if (devicesList?.length) {
                  <lib-select
                    [label]="(selectedDeviceY?.code | noUnderscore) || 'DATA_STUDIO.DATA_PARAMETERS.SELECT_DEVICE' |translate"
                    [border]="'custom-border'"
                    [fullWidth]="true"
                    [notBold]="true"
                    [classes]="'font-size-normal-small text-primary h-100 text-left'"
                    [itemClasses]="'font-size-normal-small'"
                    [options]="devicesListNames"
                    [doNotTranslate]="true"
                    [disabled]="!selectedPark"
                    (selectedChanged)="selectDeviceY($event)"
                  ></lib-select>
                }
              </div>
            }
          }
        </div>
      </div>
    }

    <!-- Signal-Y -->
    <div class="mr-4">
      <div class="mb-2 font-size-small">
        <span>{{ "DATA_STUDIO.DATA_ANALYSIS.SIGNAL_Y_TITLE" |translate }}</span>
      </div>
      <div class="selection-container">
        @if (addNewSignal) {
          @if (!signalsYAxis?.length) {
            <div class="p-2 d-flex align-items-center font-size-small new-scatter-plot-item">
              {{ "DATA_STUDIO.DATA_ANALYSIS.NO_SIGNAL" |translate }}
            </div>
          }
          @if (signalsYAxis?.length) {
            <div class="items-list mt-2">
              @if (signalsYAxis?.length) {
                <lib-select
                  [label]="signalYLabel"
                  [border]="'custom-border'"
                  [fullWidth]="true"
                  [notBold]="true"
                  [classes]="'font-size-normal-small text-primary h-100 text-left'"
                  [itemClasses]="'font-size-normal-small'"
                  [options]="signalsYAxisNames"
                  [doNotTranslate]="false"
                  [disabled]="!selectedDevice || !selectedSignalX"
                  (selectedChanged)="selectSignalY($event)"
                ></lib-select>
              }
            </div>
          }
        }
      </div>
    </div>

    @if (addNewSignal) {
      <div class="d-flex align-items-end">
        <lib-button
          id="data-analysis-scatter-plot-confirm"
          [disabled]="!selectedPark || !selectedDevice || !selectedSignalX || !selectedSignalY || serieExist"
          [label]="'BUTTONS.CONFIRM' | translate"
          class="mr-2 modify-button"
          [fontSize]="18"
          [align]="'left'"
          [color]="'primary-link'"
          (buttonClicked)="createSeries()" >
        </lib-button>
        @if (serieExist) {
          <i
            class="far fa-exclamation-circle warning-color mb-2"
            [matTooltip]="'Series already exists'"
          ></i>
        }
      </div>
    }
  </div>

  @for (serie of series; track $index) {
    <div class="mb-2 d-flex">
      <div class="mr-4">
        <div class="selection-container">
          <div class="h-100 p-2 d-flex align-items-center font-size-small new-scatter-plot-item text-primary">
            {{serie.parkDisplayName}}
          </div>
        </div>
      </div>
      <div class="mr-4">
        <div class="selection-container">
          <div class="h-100 p-2 d-flex align-items-center font-size-small new-scatter-plot-item text-primary">
            {{serie.device | noUnderscore}}
          </div>
        </div>
      </div>
      <div class="mr-4">
        <div class="selection-container">
          <div class="h-100 p-2 d-flex align-items-center font-size-small new-scatter-plot-item text-primary">
            {{serie.signalName}}
          </div>
        </div>
      </div>
      <div class="mr-4">
        <div class="selection-container">
          <div class="h-100 p-2 d-flex align-items-center font-size-small new-scatter-plot-item text-primary">
            {{serie.deviceY | noUnderscore}}
          </div>
        </div>
      </div>
      <div class="mr-4">
        <div class="selection-container">
          <div class="h-100 p-2 d-flex align-items-center font-size-small new-scatter-plot-item text-primary">
            {{serie.signalNameY}}
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <lib-button
          id="new-scatter-plot-delete-button"
          [size]="'custom'"
          [color]="'primary-link'"
          [faIcon]="'far fa-trash-alt'"
          (buttonClicked)="deleteSerie(serie)" >
        </lib-button>
      </div>
    </div>
  }

  <lib-button
    id="new-scatter-plot-add-button"
    [fontSize]="20"
    [size]="'custom'"
    [width]="36"
    [color]="'primary-link'"
    [faIcon]="'far fa-plus'"
    [disabled]="addNewSignal"
    (buttonClicked)="toggleAddNewSignal()" >
  </lib-button>

  <div class="d-flex justify-content-between">
    <div class="d-flex justify-content-start align-items-center font-size-small">
      @if (series?.length) {
        <span>
          <span class="font-weight-bold">{{series.length}}</span> {{ 'DATA_STUDIO.DATA_ANALYSIS.NEW_SELECTED' | translate }}
        </span>
      }
    </div>
    <div class="d-flex justify-content-end">
      <div class="pl-3 pr-2">
        <lib-button
          id="data-analysis-cancel-button"
          [color]="'secondary'"
          [label]="'BUTTONS.CANCEL' | translate"
          (buttonClicked)="close()" >
        </lib-button>
      </div>
      <div class="pr-3">
        <lib-button
          id="data-analysis-save-button"
          [label]="'BUTTONS.ADD' |translate"
          [disabled]="!series?.length"
          (buttonClicked)="addNewSeries()" >
        </lib-button>
      </div>
    </div>
  </div>
</div>
